import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "name", "id", "error", "error_message", "options", "onChange", "hiddeTitle", "haveEmptyOption", "selectClassName"],
    _excluded2 = ["control", "name", "options"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { Controller } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function Select(props) {
  var label = props.label,
      name = props.name,
      id = props.id,
      error = props.error,
      error_message = props.error_message,
      options = props.options,
      onChange = props.onChange,
      _props$hiddeTitle = props.hiddeTitle,
      hiddeTitle = _props$hiddeTitle === void 0 ? false : _props$hiddeTitle,
      haveEmptyOption = props.haveEmptyOption,
      selectClassName = props.selectClassName,
      passThroughProps = _objectWithoutProperties(props, _excluded);

  var focusClass = error ? 'focus-within:border-red focus-within:ring-red border-red' : 'focus-within:border-black focus-within:ring-black';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx('relative  rounded-md border border-gray-300 bg-white px-1', focusClass, {
        'pt-4': !hiddeTitle
      }),
      children: [/*#__PURE__*/_jsxs("select", _objectSpread(_objectSpread({
        id: "location",
        name: "location",
        className: clsx('peer h-12 w-full border-0 text-gray-900 placeholder-transparent focus:outline-none focus:ring-0', selectClassName),
        defaultValue: "United Kingdom",
        onChange: onChange
      }, passThroughProps), {}, {
        children: [haveEmptyOption && /*#__PURE__*/_jsx("option", {
          disabled: true,
          selected: true,
          value: ""
        }), options.map(function (option) {
          return /*#__PURE__*/_jsx("option", {
            value: option.value,
            children: option.label
          }, option.value);
        })]
      })), /*#__PURE__*/_jsx("label", {
        htmlFor: "email",
        className: "absolute left-4 top-2 text-sm text-gray-600 transition-all peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-sm peer-focus:text-gray-600",
        children: label
      })]
    }), error && /*#__PURE__*/_jsx("p", {
      className: "text-red mt-2 text-sm",
      children: error_message
    })]
  });
}
export var SelectControlled = function SelectControlled(_ref) {
  var control = _ref.control,
      name = _ref.name,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, _excluded2);

  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: name,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          value = _ref2$field.value,
          onChange = _ref2$field.onChange;
      return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
        value: value,
        onChange: onChange,
        options: options
      }));
    }
  });
};
export default Select;